import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/lazy';
import {
  AppTrackingStatusResponse,
  AppTrackingTransparency,
} from 'capacitor-plugin-app-tracking-transparency';


@Injectable({
  providedIn: 'root'
})

export class TrackingDataService {

  constructor(
    private platform: Platform
  ) {

  }

  public async getStatus(): Promise<AppTrackingStatusResponse> {
    // Il tracking transparency è disponibile solo su iOS
    if (this.platform.is('android')) {
      console.log('App Tracking Transparency non disponibile su Android');
      return { status: 'notDetermined' };
    }

    const response = await AppTrackingTransparency.getStatus();

    console.log(response);
    // { status: 'authorized' } for example

    return response;
  }

  public async requestPermission(): Promise<AppTrackingStatusResponse> {
    // Il tracking transparency è disponibile solo su iOS
    if (this.platform.is('android')) {
      console.log('App Tracking Transparency non disponibile su Android');
      return { status: 'notDetermined' };
    }

    const response = await AppTrackingTransparency.requestPermission();

    console.log(response);
    // { status: 'authorized' } for example

    return response;
  }

}